import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import DialogV2 from 'common/modal/DialogV2';
import { ENROLLMENT_BULK_ACTION_LIMIT } from 'pages/enrollments/constants';
import BulkActionButton from './BulkActionButton';

const WorkqueueBulkAction = ({
  action,
  open,
  children,
  close,
  dialogRef,
  onSubmit,
  bulkActionIcon,
  dialogTitle,
  disableOpenModal,
  selectedRows,
  disableSubmitRowsButton,
  erroredRows,
  bulkActionIconSize,
}) => {
  useEffect(() => {
    if (selectedRows.length === 0) {
      close();
    }
  }, [selectedRows]);
  const shouldDisableConfirmationButton = (erroredRows ||
    selectedRows.length > ENROLLMENT_BULK_ACTION_LIMIT) ||
    disableSubmitRowsButton;

  return (
    <div className="flex items-end mb-2 mx-0">
      <BulkActionButton
        action={action}
        onClick={open}
        icon={bulkActionIcon}
        disabled={disableOpenModal}
        iconSize={bulkActionIconSize}
      />
      <DialogV2
        ref={dialogRef}
        title={dialogTitle}
        confirmLabel={action}
        confirmationHandler={onSubmit}
        cancelHandler={close}
        width="3xl"
        showIconWithConfirmLabel
        confirmButtonIcon={bulkActionIcon}
        confirmButtonIconColor="white"
        confirmationBtnDisabled={shouldDisableConfirmationButton}
      >
        {children}
      </DialogV2>
    </div>
  );
};

WorkqueueBulkAction.propTypes = {
  dialogTitle: PropTypes.string.isRequired,
  bulkActionIcon: PropTypes.string.isRequired,
  open: PropTypes.func.isRequired,
  action: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  close: PropTypes.func.isRequired,
  dialogRef: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  disableOpenModal: PropTypes.bool.isRequired,
  selectedRows: PropTypes.array.isRequired,
  disableSubmitRowsButton: PropTypes.bool,
  erroredRows: PropTypes.array.isRequired,
  bulkActionIconSize: PropTypes.number,
};

WorkqueueBulkAction.defaultProps = {
  disableSubmitRowsButton: false,
  bulkActionIconSize: 25,
};
export default WorkqueueBulkAction;
